import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(LanguageDetector) 
  .use(initReactI18next) // 💡 Assure-toi que cette ligne est bien présente
  .init({
    resources: {
        en: { translation: require('./locales/en/translation.json') },
        fr: { translation: require('./locales/fr/translation.json') }
      },
      lng: localStorage.getItem('i18nextLng') || 'fr', // Langue par défaut
    fallbackLng: "fr",
    interpolation: { escapeValue: false },
    detection: { order: ["localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
